<template>
  <svg enable-background="new 0 0 512 512" height="512px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g>
      <path clip-rule="evenodd" d="M256.23,512C396.81,512,512,396.81,512,256.23   C512,115.184,396.81,0,256.23,0C115.184,0,0,115.184,0,256.23C0,396.81,115.184,512,256.23,512L256.23,512z" fill="#FFFFFF" fill-rule="evenodd"/>
      <path clip-rule="evenodd" d="M224.023,160.085c0-35.372,28.575-63.946,63.938-63.946h48.072   v63.946h-32.199c-8.608,0-15.873,7.257-15.873,15.873v32.192h48.072v63.938h-48.072v144.22h-63.938v-144.22h-48.065V208.15h48.065   V160.085z" fill="#1877f2" fill-rule="evenodd"/>
    </g>
  </svg>
</template>
